





import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class UserType extends Vue {
  @Prop()
  row!: any

  @Prop({ default: 'is-small' }) size?: string
}
